import type { Icon } from '../../../src/lib/types'
export const mdiPlus: Icon = {
  "id": "plus",
  "name": "Plus",
  "path": "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  "as": [
    "add"
  ],
  "tags": [
    "Math"
  ]
}
export default mdiPlus